import React, { useState, useEffect, useContext } from 'react';
import { useLocation, MemoryRouter } from 'react-router-dom';
import './game.scss';


// Contexts
import { StateContext } from '../../contexts/state';


// Assets
import { ReactComponent as Loader } from '../../assets/loading-indicator.svg';
import logo from '../../assets/logo-big.svg';
import { WEBSITE_BASE_URL } from '../../config/consts';

const GameView = () => {

    function useQuery() {
        return new URLSearchParams(useLocation().search);
      }
    const dataContext = useContext(StateContext);
    const gameId = useQuery().get('game');
    const [game, setGame] = useState();
    const [loaded, setLoaded] = useState(false);

    function getCurrentGame() {
        if (dataContext.data.current) {
            return dataContext.data.current;
        } else {
            return dataContext.data.data.content.find((game) => game.id === gameId);
        }
    }

    useEffect(() => {
        if (!dataContext.data?.data?.content?.length || game) return;

        const currentGame = getCurrentGame();

        if (currentGame) {
            setGame(currentGame);
        }
    }, [dataContext.data]);

    // useEffect(() => {
    //     if (game) {
    //         widgetRenderer.updateSize(game.width, game.height);
    //     }
    // }, [game]);

    return (
        <div className='game-view'>
        <div className="game-view__logo-container" >
            <img className="game-view__logo" src={logo}></img>
        </div>
            {game && <div className='game-view__game-container'>
            <iframe
                src={`${WEBSITE_BASE_URL}${game?.url}`}
                width={game?.width}
                height={game?.height}
                id='arrow-arcade-game'
                frameBorder='0'
                marginHeight='0'
                marginWidth='0'
                scrolling='no'
                className='game-view__game'
                onLoad={() => setLoaded(true)}
            ></iframe>
            </div>}
            {!loaded && (
                <div className='game-view__loader'>
                    <Loader />
                </div>
            )}
            <div className="game-view__bottom">

            </div>
            {/* <MemoryRouter>
                <HomeView/>
            </MemoryRouter> */}
        </div>
    );
};

export default GameView;
